import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { api_url } from '../../utils/utils';

// ================= ADD =================
export const brandAdd = createAsyncThunk(
  'brand/brandAdd',
  async ({ name }, { rejectWithValue, fulfillWithValue, getState }) => {
    try {
      const token = getState().auth.token;

      const { data } = await axios.post(
        `${api_url}/api/brand-add`,
        { name },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// ================= EDIT =================
export const brandEdit = createAsyncThunk(
  'brand/brandEdit',
  async ({ id, name }, { rejectWithValue, fulfillWithValue, getState }) => {
    try {
      const token = getState().auth.token;

      const { data } = await axios.put(
        `${api_url}/api/brand-edit/${id}`,
        { id, name },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// ================= DELETE =================
export const brandDelete = createAsyncThunk(
  'brand/brandDelete',
  async (id, { rejectWithValue, fulfillWithValue, getState }) => {
    try {
      const token = getState().auth.token;

      const { data } = await axios.delete(`${api_url}/api/brand-delete/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// ================= GET =================
export const get_brand = createAsyncThunk(
  'brand/get_brand',
  async ({ page = 1, parPage = 5, searchValue = '' }, { rejectWithValue, fulfillWithValue, getState }) => {
    try {
      const token = getState().auth.token;

      const { data } = await axios.get(
        `${api_url}/api/brand-get`,
        {
          params: { page, parPage, searchValue },
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// ================= SLICE =================
const brandReducer = createSlice({
  name: 'brand',
  initialState: {
    loader: false,
    successMessage: '',
    errorMessage: '',
    brands: [],
    totalBrand: 0
  },
  reducers: {
    messageClear: (state) => {
      state.successMessage = '';
      state.errorMessage = '';
    }
  },
  extraReducers: {
    // ADD
    [brandAdd.pending]: (state) => {
      state.loader = true;
    },
    [brandAdd.fulfilled]: (state, { payload }) => {
      state.loader = false;
      state.successMessage = payload.message;
      state.brands.push(payload.brand);
    },
    [brandAdd.rejected]: (state, { payload }) => {
      state.loader = false;
      state.errorMessage = payload.error;
    },

    // EDIT
    [brandEdit.pending]: (state) => {
      state.loader = true;
    },
    [brandEdit.fulfilled]: (state, { payload }) => {
      state.loader = false;
      state.successMessage = payload.message;
      // Optionally update local brand list if you want
      const index = state.brands.findIndex(b => b._id === payload.brand?._id);
      if (index !== -1 && payload.brand) state.brands[index] = payload.brand;
    },
    [brandEdit.rejected]: (state, { payload }) => {
      state.loader = false;
      state.errorMessage = payload.error;
    },

    // DELETE
    [brandDelete.pending]: (state) => {
      state.loader = true;
    },
    [brandDelete.fulfilled]: (state, { payload }) => {
      state.loader = false;
      state.successMessage = payload.message;
      state.brands = state.brands.filter(b => b._id !== payload.id);
    },
    [brandDelete.rejected]: (state, { payload }) => {
      state.loader = false;
      state.errorMessage = payload.error;
    },

    // GET
    [get_brand.fulfilled]: (state, { payload }) => {
      state.brands = payload.brands || payload;
      state.totalBrand = payload.totalBrand || payload.length;
    }
  }
});

export const { messageClear } = brandReducer.actions;
export default brandReducer.reducer;
